import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const DocumentFilled = (props : SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70">
      <g id="picto" transform="translate(-668 -150)">
        <circle id="bg" cx="35" cy="35" r="35" transform="translate(668 150)" fill="#e67e22"/>
        <g id="documents" transform="translate(687.01 166.262)">
          <path id="Tracé_441" data-name="Tracé 441" d="M22.738,2H7.748A3.748,3.748,0,0,0,4,5.748V35.729a3.748,3.748,0,0,0,3.748,3.748H30.233a3.748,3.748,0,0,0,3.748-3.748V13.243Z" transform="translate(-3 -1)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          <path id="Tracé_442" data-name="Tracé 442" d="M14,2V13.243H25.243" transform="translate(5.738 -1)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          <line id="Ligne_6" data-name="Ligne 6" x1="14" transform="translate(8.99 21.738)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          <line id="Ligne_7" data-name="Ligne 7" x1="14" transform="translate(8.99 28.738)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          <path id="Tracé_443" data-name="Tracé 443" d="M11.748,9H8" transform="translate(0.495 5.117)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default DocumentFilled;